import React from "react";
import { Col, Row, TabContent, TabPane } from "reactstrap";
import { BackgroundPillTabData } from "../../../../Data/UiKits/Tabs";
import { SimpleTabContentProp } from "../../../../Types/UiKitsType";
import { Image } from "../../../../AbstractElements";
import { dynamicImage } from "../../../../Utils";

const BackgroundPillTabContent: React.FC<SimpleTabContentProp> = ({ tabId }) => {
  return (
    <TabContent activeTab={tabId}>
      {BackgroundPillTabData &&
        BackgroundPillTabData.map((item, index) => (
          <TabPane className={`fade ${tabId === item.id ? "show" : ""}`} tabId={item.id} key={index}>
            <Row className="g-3 pt-3">
              <Col xs="4"><Image className="img-fluid" src={dynamicImage(`switch/${item.image}1.jpg`)} alt="sofa" /></Col>
              <Col xs="4"><Image className="img-fluid" src={dynamicImage(`switch/${item.image}2.jpg`)} alt="sofa" /></Col>
              <Col xs="4"><Image className="img-fluid" src={dynamicImage(`switch/${item.image}3.jpg`)} alt="sofa" /></Col>
            </Row>
          </TabPane>
        ))}
    </TabContent>
  );
};
export default BackgroundPillTabContent;
